import { Component, OnDestroy, OnInit } from "@angular/core";
import { SessionService } from "./services/session.service";
import { AuthService } from "./components/auth/auth.service";
import { Subject, takeUntil } from "rxjs";
import { InactivityService } from "@services/inactivity.service";
import { SessionTimerService } from "@services/session-expiracion.service";
import { ExtenderSesionService } from "@services/extender-sesion.service";
import { AutoExtenderSesionService } from "@services/auto-extender-sesion.service";
import { SessionCaducadaService } from "@services/session-caducada.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  sidebarOpen = false;
  isAuthenticated = false;
  mostrarModalInactividad: boolean = false;
  prolongandoSesion: boolean = false;
  sesionCaducada: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(
    private sessionService: SessionService,
    private auth: AuthService,
    private inactivityService: InactivityService,
    private sessionTimerService: SessionTimerService,
    private extenderSesionService: ExtenderSesionService,
    private autoExtenderSesionService: AutoExtenderSesionService,
    private sessionCaducadaService: SessionCaducadaService,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.inactivityService.eliminarEventos();
    this.autoExtenderSesionService.stop();
    this.sessionTimerService.stop();
  }

  ngOnInit(): void {
    this.sessionService.sesion$.pipe(takeUntil(this.destroy$)).subscribe(sesion => {
      this.isAuthenticated = !!sesion;
      if (sesion) {
        this.inactivityService.startWatching();
        this.autoExtenderSesionService.start();
      } else {
        this.inactivityService.eliminarEventos();
        this.autoExtenderSesionService.stop();
        this.mostrarModalInactividad = false;
      }
    });

    this.sessionTimerService.watchSession();

    this.sessionTimerService.sessionExpiring$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.mostrarModalInactividad = true;
      });

    this.sessionTimerService.sessionExpired$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.mostrarModalInactividad = false;
        if (this.sessionService.isAuthenticated()) {
          this.auth.logout();
        }
      });

    this.sessionCaducadaService.caducada$
      .pipe(takeUntil(this.destroy$))
      .subscribe((caducada) => {
        this.sesionCaducada = caducada;
        if (caducada) {
          this.mostrarModalInactividad = false;
          this.inactivityService.eliminarEventos();
          this.autoExtenderSesionService.stop();
          this.sessionTimerService.stop();
        }
      });
  }

  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
  }

  prolongarSesion(): void {
    if (this.prolongandoSesion) return;
    this.prolongandoSesion = true;

    const minutos = 10;

    this.extenderSesionService
      .extenderSesion<any>(minutos)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (!response?.success) {
            this.prolongandoSesion = false;
            console.warn("No se pudo prolongar la sesión:", response?.msg);
            return;
          }

          const sesion = this.sessionService.getSesionActual();
          const actual = sesion?.expiracion ? new Date(sesion.expiracion).getTime() : Date.now();
          const nuevaExpiracion = new Date(actual + minutos * 60 * 1000).toISOString();

          this.sessionService.actualizarFechasSesion(nuevaExpiracion);
          this.inactivityService.resetear();
          this.mostrarModalInactividad = false;
          this.prolongandoSesion = false;
        },
        error: (err) => {
          this.prolongandoSesion = false;
          console.error("Error al prolongar sesión:", err);
        },
      });
  }

  cerrarSesion(): void {
    this.mostrarModalInactividad = false;
    this.auth.logout();
  }
}
